export const FACEBOOK_BLUE = '#4267b2';

export function FacebookIcon({ size = 16, white = false }) {
    const color = white ? '#ffffff' : FACEBOOK_BLUE;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 216 216"
            color={color}
            height={size}
            width={size}
            style={{ verticalAlign: 'middle', marginTop: '-0.1em' }}>
            <path
                fill={color}
                d=" M204.1 0H11.9C5.3 0 0 5.3 0 11.9v192.2c0 6.6 5.3 11.9 11.9 11.9h103.5v-83.6H87.2V99.8h28.1v-24c0-27.9 17-43.1 41.9-43.1 11.9 0 22.2.9 25.2 1.3v29.2h-17.3c-13.5 0-16.2 6.4-16.2 15.9v20.8h32.3l-4.2 32.6h-28V216h55c6.6 0 11.9-5.3 11.9-11.9V11.9C216 5.3 210.7 0 204.1 0Z"
            />
        </svg>
    );
}

export function FacebookProfileIcon({ facebookUserId = '', size = 64 }) {
    if (facebookUserId) {
        return (
            <img
                src={`https://graph.facebook.com/v17.0/${facebookUserId}/picture?type=square&height=${size}&width=${size}`}
                width={size}
                height={size}
                style={{ borderRadius: '50%' }}
                alt=""
            />
        );
    } else {
        return <ProfileIcon size={size} />;
    }
}

export function ProfileIcon({ size = 64 }) {
    const height = size;
    const width = size;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 80 80"
            height={height}
            width={width}>
            <g>
                <circle fill="#eaeaea" cx="40" cy="40" r="40" />
                <path
                    fill="#c9c9c9"
                    d="M12.5471636,69.0582977 C13.3243079,68.6078891 14.1457772,68.2049695 15.0115741,67.849537 C17.5038705,66.8263838 19.9961295,65.8557145 22.4884259,64.9375 C24.9807223,64.0192855 27.1057011,62.8256246 28.8634259,61.3564815 C30.6211508,59.8873383 31.5,58.1296399 31.5,56.0833333 C31.2901224,55.8734557 30.9884279,55.5455269 30.5949074,55.099537 C30.2013869,54.6535472 29.519295,53.6566435 28.5486111,52.1087963 C27.5779272,50.5609491 26.7121952,48.921305 25.9513889,47.1898148 C25.1905826,45.4583247 24.5084907,43.2152916 23.9050926,40.4606481 C23.3016945,37.7060047 23,34.8858169 23,32 C23,27.3302236 24.6658784,23.329492 27.9976852,19.9976852 C31.329492,16.6658784 35.3302236,15 40,15 C44.6697764,15 48.670508,16.6658784 52.0023148,19.9976852 C55.3341216,23.329492 57,27.3302236 57,32 C57,34.8858169 56.7114226,37.6928876 56.1342593,40.4212963 C55.5570959,43.149705 54.8487696,45.4189724 54.0092593,47.2291667 C53.1697489,49.0393609 52.3302511,50.6396535 51.4907407,52.0300926 C50.6512304,53.4205316 49.9429041,54.4567867 49.3657407,55.1388889 L48.5,56.0833333 C48.5,58.1296399 49.3788492,59.8873383 51.1365741,61.3564815 C52.8942989,62.8256246 55.0192777,64.0192855 57.5115741,64.9375 C60.0038705,65.8557145 62.4961295,66.8263838 64.9884259,67.849537 C65.8641222,68.2090334 66.6944714,68.6171091 67.4794763,69.073766 C52.3150335,83.6488934 27.4646266,83.6481398 12.5471636,69.0582977 Z"
                />
            </g>
        </svg>
    );
}

export function CheckSymbol({ size = 16, color = 'currentColor' }) {
    const height = size;
    const width = (size * 31) / 24;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 31 24"
            height={height}
            width={width}
            style={{ verticalAlign: 'middle' }}>
            <g transform="translate(-277.000000, -2527.000000)">
                <path
                    fill={color}
                    d="M288.753473,2550.62847 C288.591436,2550.74421 288.440974,2550.80208 288.302084,2550.80208 C288.163195,2550.80208 288.012733,2550.74421 287.850696,2550.62847 L277.225696,2540.00347 C276.924768,2539.70255 276.924768,2539.40162 277.225696,2539.1007 L281.600696,2534.7257 C281.901623,2534.42477 282.202546,2534.42477 282.503473,2534.7257 L288.302084,2540.55903 L301.600696,2527.2257 C301.901623,2526.92477 302.202546,2526.92477 302.503473,2527.2257 L306.878473,2531.6007 C307.179401,2531.90162 307.179401,2532.20255 306.878473,2532.50347 L288.753473,2550.62847 Z"
                />
            </g>
        </svg>
    );
}

export function BackSymbol({ size = 16, color = 'currentColor' }) {
    const height = size;
    const width = (size * 8) / 12;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 8 12"
            height={height}
            width={width}
            style={{ verticalAlign: 'middle' }}>
            <g transform="translate(-140.000000, -320.000000)">
                <path
                    fill={color}
                    transform="translate(144.000000, 325.979274) scale(-1, 1) translate(-144.000000, -325.979274)"
                    d="M142.010363,320 C142.065631,320 142.125504,320.023028 142.189983,320.069085 L147.91019,325.789291 C148.029937,325.909039 148.029937,326.028784 147.91019,326.148531 L142.189983,331.868738 C142.070236,331.988485 141.95049,331.988485 141.830743,331.868738 L140.08981,330.127805 C139.970063,330.008058 139.970063,329.888313 140.08981,329.768565 L143.889465,325.968911 L140.08981,322.169257 C139.970063,322.04951 139.970063,321.929764 140.08981,321.810017 L141.830743,320.069085 C141.895222,320.023028 141.955095,320 142.010363,320 L142.010363,320 Z"
                />
            </g>
        </svg>
    );
}

export function HelpSymbol({ size = 16, color = 'currentColor' }) {
    const height = size;
    const width = size;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 30 30"
            height={height}
            width={width}
            style={{ verticalAlign: 'middle' }}>
            <g transform="translate(-277.000000, -2646.000000)">
                <path
                    fill={color}
                    d="M292,2646 C296.120391,2646 299.650448,2647.46989 302.590278,2650.40972 C305.530107,2653.34955 307,2656.87961 307,2661 C307,2665.14354 305.535894,2668.67938 302.607639,2671.60764 C299.679384,2674.53589 296.143539,2676 292,2676 C287.856461,2676 284.320616,2674.53589 281.392361,2671.60764 C278.464106,2668.67938 277,2665.14354 277,2661 C277,2656.85646 278.464106,2653.32062 281.392361,2650.39236 C284.320616,2647.46411 287.856461,2646 292,2646 L292,2646 Z M292,2672.25 C292.694448,2672.25 293.28472,2672.00695 293.770833,2671.52083 C294.256947,2671.03472 294.5,2670.44445 294.5,2669.75 C294.5,2669.05555 294.256947,2668.46528 293.770833,2667.97917 C293.28472,2667.49305 292.694448,2667.25 292,2667.25 C291.305552,2667.25 290.71528,2667.49305 290.229167,2667.97917 C289.743053,2668.46528 289.5,2669.05555 289.5,2669.75 C289.5,2670.44445 289.743053,2671.03472 290.229167,2671.52083 C290.71528,2672.00695 291.305552,2672.25 292,2672.25 L292,2672.25 Z M293.875,2663.5 C293.875,2663.17592 294.048609,2662.86343 294.395833,2662.5625 C294.743057,2662.26157 295.15972,2661.96644 295.645833,2661.67708 C296.131947,2661.38773 296.618053,2661.05209 297.104167,2660.67014 C297.59028,2660.28819 298.006943,2659.75 298.354167,2659.05556 C298.701391,2658.36111 298.875,2657.55093 298.875,2656.625 C298.875,2654.79629 298.215284,2653.29746 296.895833,2652.12847 C295.576382,2650.95948 293.944454,2650.375 292,2650.375 C290.888883,2650.375 289.812505,2650.63541 288.770833,2651.15625 C287.729161,2651.67709 286.96528,2652.2037 286.479167,2652.73611 L285.75,2653.5 L288.25,2656 C288.38889,2655.86111 288.57986,2655.6875 288.822917,2655.47917 C289.065973,2655.27083 289.517358,2654.99306 290.177083,2654.64583 C290.836809,2654.29861 291.444442,2654.125 292,2654.125 C292.902782,2654.125 293.649303,2654.37963 294.239583,2654.88889 C294.829864,2655.39815 295.125,2655.97685 295.125,2656.625 C295.125,2657.18056 294.864586,2657.68403 294.34375,2658.13542 C293.822914,2658.58681 293.250003,2658.96875 292.625,2659.28125 C291.999997,2659.59375 291.427086,2660.0625 290.90625,2660.6875 C290.385414,2661.3125 290.125,2662.04166 290.125,2662.875 L290.125,2664.125 L293.875,2664.125 L293.875,2663.5 Z"
                />
            </g>
        </svg>
    );
}

export function WarningSymbol({ size = 16, color = 'currentColor' }) {
    const height = size;
    const width = (size * 31) / 30;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 31 30"
            height={height}
            width={width}
            style={{ verticalAlign: 'middle' }}>
            <g transform="translate(-277.000000, -2463.000000)">
                <path
                    fill={color}
                    d="M306.67316,2488.48611 C307.20557,2489.52778 307.170848,2490.53472 306.568994,2491.50694 C305.94399,2492.50232 305.052796,2493 303.895382,2493 L280.145382,2493 C278.987969,2493 278.096774,2492.50232 277.471771,2491.50694 C276.893065,2490.55787 276.846769,2489.55093 277.332882,2488.48611 L289.207882,2464.73611 C289.809737,2463.5787 290.747228,2463 292.020382,2463 C293.316685,2463 294.242602,2463.5787 294.79816,2464.73611 L306.67316,2488.48611 Z M290.145382,2471.125 L290.145382,2481.75 L293.895382,2481.75 L293.895382,2471.125 L290.145382,2471.125 Z M292.020382,2489.875 C292.71483,2489.875 293.305102,2489.63195 293.791216,2489.14583 C294.277329,2488.65972 294.520382,2488.06945 294.520382,2487.375 C294.520382,2486.68055 294.277329,2486.09028 293.791216,2485.60417 C293.305102,2485.11805 292.71483,2484.875 292.020382,2484.875 C291.325934,2484.875 290.735663,2485.11805 290.249549,2485.60417 C289.763436,2486.09028 289.520382,2486.68055 289.520382,2487.375 C289.520382,2488.06945 289.763436,2488.65972 290.249549,2489.14583 C290.735663,2489.63195 291.325934,2489.875 292.020382,2489.875 L292.020382,2489.875 Z"
                />
            </g>
        </svg>
    );
}
